const initMuSearchMobile = () => {
    const $searchButton = $(".mu-nav-search-icon");
    const $searchMenu = $("#mobileSearch");
    const $hamburger = $(".mu-nav-hamburger");
    const $navbar = $("nav.navbar.navbar-mobile");

    // Guard: require key elements
    if ($searchButton.length === 0 || $hamburger.length === 0 || $navbar.length === 0) {
        return;
    }

    const isMenuOpen = () => $navbar.hasClass("is-open");
    const isSearchOpen = () =>
        $searchMenu.hasClass("show") || $searchButton.attr("aria-expanded") === "true";

    // Adapter to hide the dropdown regardless of Bootstrap version
    const hideDropdown = () => {
        const btn = $searchButton.get(0);
        const menuEl = $searchMenu.get(0);

        if (typeof window.bootstrap !== "undefined" && window.bootstrap.Dropdown) {
            window.bootstrap.Dropdown.getOrCreateInstance(btn).hide();
        } else if (window.jQuery && jQuery.fn.dropdown) {
            // Bootstrap 4
            jQuery(btn).dropdown("hide");
        } else {
            // Fallback
            menuEl?.classList.remove("show");
            btn?.setAttribute("aria-expanded", "false");
        }
    };

    // Focus management after dropdown opens
    const focusSearchInput = () => {
        // Small delay to ensure dropdown is rendered
        setTimeout(() => {
            if ($searchInput.length) {
                $searchInput.trigger("focus");
            }
        }, 300);
    };

    // Debounced hamburger close (helps with iOS ghost clicks)
    let lastCloseTs = 0;
    const safeHamburgerClose = () => {
        const now = Date.now();
        if (now - lastCloseTs > 120) {
            $hamburger.trigger("click");
            lastCloseTs = now;
        }
    };

    // ---- KEY FIX ----
    // Use native pointerdown (capture: true) to run before Bootstrap handles the click.
    const searchBtnEl = $searchButton.get(0);
    const hamburgerEl = $hamburger.get(0);

    if (searchBtnEl) {
        searchBtnEl.addEventListener(
            "pointerdown",
            () => {
                if (isMenuOpen()) {
                    safeHamburgerClose();
                }
            }, {
                capture: true
            }
        );
    }

    if (hamburgerEl) {
        hamburgerEl.addEventListener(
            "pointerdown",
            () => {
                if (isSearchOpen()) {
                    hideDropdown();
                }
            }, {
                capture: true
            }
        );
    }

    // Normal click: ensure menu is closed, let Bootstrap open dropdown, then focus input.
    $searchButton.on("click", () => {
        if (isMenuOpen()) {
            safeHamburgerClose();
        }
        focusSearchInput();
    });

    // Accessibility: ESC closes search and returns focus to toggle
    $(document).on("keydown", (e) => {
        if (e.key === "Escape" && isSearchOpen()) {
            hideDropdown();
            $searchButton.trigger("focus");
        }
    });
};

export default initMuSearchMobile;